module.exports = __webpack_public_path__ + "img/portal-img.3fbdbc1a.png";